export { default } from "./ClubDetailStructuredData";
